"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constant = require("./constant");
var _default = {
  PropTypes: {
    title: _propTypes.default.string.isRequired,
    message: _propTypes.default.string.isRequired,
    url: _propTypes.default.string.isRequired,
    width: _propTypes.default.string,
    textWidth: _propTypes.default.string,
    placeHolderBackground: _propTypes.default.string,
    showButton: _propTypes.default.bool,
    showSecondaryButton: _propTypes.default.bool,
    buttonText: _propTypes.default.string,
    secondaryButtonText: _propTypes.default.string,
    isLoading: _propTypes.default.bool,
    handleOnClick: _propTypes.default.func,
    handleOnClickSecondary: _propTypes.default.func
  },
  DefaultTypes: {
    title: '',
    message: '',
    url: _constant.IMAGE_URL,
    placeHolderBackground: 'default',
    handleOnClick: function handleOnClick() {},
    handleOnClickSecondary: function handleOnClickSecondary() {}
  }
};
exports.default = _default;